var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd0d1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#128415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a650c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf94f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f736"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d50b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15439d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.095238v11.428571h-6.095238z",
    fill: "url(#d)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.0952381 7.23809524c.84157676 0 1.52380952-.68223276 1.52380952-1.52380953 0-.84157676-.68223276-1.52380952-1.52380952-1.52380952-.84157677 0-1.52380953.68223276-1.52380953 1.52380952 0 .84157677.68223276 1.52380953 1.52380953 1.52380953zm0 .76190476c-1.26236515 0-2.28571429-1.02334914-2.28571429-2.28571429 0-1.26236514 1.02334914-2.28571428 2.28571429-2.28571428 1.26236514 0 2.28571428 1.02334914 2.28571428 2.28571428 0 1.26236515-1.02334914 2.28571429-2.28571428 2.28571429z",
    fill: "url(#e)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.33333333 4.76630728c0-.10762854.08192662-.19487871.18684896-.19487871h1.15011161c.10319383 0 .18684896.08681161.18684896.19487871v1.32972582c0 .42034931-.33818272.76110976-.76190476.76110976-.42078839 0-.76190477-.33726502-.76190477-.76110976z",
    fill: "url(#a)",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.0952381 6.0952381c.21039418 0 .38095238-.55151058.38095238-.76190477 0-.21039418-.1705582-.38095238-.38095238-.38095238-.21039419 0-.38095239.1705582-.38095239.38095238 0 .21039419.1705582.76190477.38095239.76190477z",
    fill: "url(#f)",
    mask: "url(#g)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/PT.c7fbfc4fbfcc78b73482a7c12cd96223.svg";
export { ForwardRef as ReactComponent };